"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessBasketPayment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var pages_1 = require("../../../../constants/pages");
var letstrade_new_png_1 = __importDefault(require("../../../../assets/logos/letstrade_new.png"));
var get_transaction_1 = require("../../../../api/calls/payments/payment_engine/get_transaction");
var checkout_1 = require("../../../../api/calls/basket/checkout");
var main_1 = require("../../../../reducers/slices/main");
var SuccessBasketPayment = function () {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var params = (0, react_router_dom_1.useParams)();
    var _b = (0, react_1.useState)(false), loading = _b[0], setLoading = _b[1];
    var _c = (0, react_1.useState)(null), basket = _c[0], setBasket = _c[1];
    var _d = (0, react_1.useState)([]), products = _d[0], setProducts = _d[1];
    var basketID = params.basketID, userID = params.userID, paymentIdentifier = params.paymentIdentifier;
    (0, react_1.useEffect)(function () {
        setLoading(true);
        var paymentEngineToken = localStorage.getItem("paymentEngineToken");
        var clientToken = localStorage.getItem("clientToken");
        (0, get_transaction_1.get_transaction)({ ref: paymentIdentifier }, paymentEngineToken).then(function (transactionRes) {
            var _a;
            if (transactionRes.success && ((_a = transactionRes === null || transactionRes === void 0 ? void 0 : transactionRes.content) === null || _a === void 0 ? void 0 : _a.status) == "SUCCESS") {
                localStorage.clear();
                var _id = (transactionRes === null || transactionRes === void 0 ? void 0 : transactionRes.content)._id;
                (0, checkout_1.checkout)({ _id: basketID, transaction: { _id: _id } }).then(function (checkoutRes) {
                    if (checkoutRes.success) {
                        var content = checkoutRes.content;
                        setBasket(content);
                        if ((content === null || content === void 0 ? void 0 : content.product_list) && (content === null || content === void 0 ? void 0 : content.product_list.length) > 0) {
                            setProducts(content === null || content === void 0 ? void 0 : content.product_list.map(function (x) {
                                if ((x === null || x === void 0 ? void 0 : x.variations) && x.variations.length > 0 && (x === null || x === void 0 ? void 0 : x.variations[0].variations) && (x === null || x === void 0 ? void 0 : x.variations[0].variations.length) > 0) {
                                    var _variation = x === null || x === void 0 ? void 0 : x.variations[0].variations[0];
                                    return __assign(__assign({}, x), { title: "".concat(x.title, " - ").concat(_variation.title), price: _variation.price });
                                }
                                return x;
                            }));
                        }
                        setLoading(false);
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [checkoutRes.message] }));
                    }
                });
            }
            else {
                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [transactionRes.message] }));
            }
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "container mx-auto p-4 " }, { children: loading ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.CircularLoaderControl, { size: "xlarge" }) }))) : ((0, jsx_runtime_1.jsxs)("div", __assign({ className: " flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "pb-18 flex justify-center" }, { children: (0, jsx_runtime_1.jsx)("img", { src: letstrade_new_png_1.default, className: "w-1/5" }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-4 p-4 border border-success rounded-md" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "text-success w-10 h-10 rounded-full border border-success flex items-center justify-center" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheck }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Payment Success", bold: true, textColor: "text-black", size: "xlarge" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Order #".concat(basketID), size: "small" })] }))] })) })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Items in your order" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.TableControl, { columns: [
                            {
                                displayKey: "title",
                                label: "Item",
                            },
                            {
                                displayKey: "quantity",
                                label: "Quantity",
                            },
                            {
                                displayKey: "price",
                                label: "Price",
                            },
                        ], data: products, colors: pages_1.tableColorConfig }) })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "You paid R".concat((_a = basket === null || basket === void 0 ? void 0 : basket.total) !== null && _a !== void 0 ? _a : 0) })] }))) })));
};
exports.SuccessBasketPayment = SuccessBasketPayment;
